import { Card as MuiCard } from '@mui/material';
import styled from 'styled-components';

export const Card = styled(MuiCard)`
  background-color: #eee;
  border-radius: 20px;
`;

export const CardTooltip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: help;
  }
`;
